export default __webpack_public_path__ + "static/media/ujwal new.9dce25af.png";